import { API_BASE_URL } from "../lib/env.js";
import { AuthFrame } from "../components/AuthFrame.js";

/**
 * Sign-in. The browser never handles a token: it navigates to the API, which
 * runs the OAuth exchange server-side and sets an httpOnly cookie. That is why
 * this screen is links rather than a form — there is no credential for the SPA
 * to hold, and nothing for a script on the page to steal.
 */
const login = (provider: "google" | "authkit"): string =>
  `${API_BASE_URL}/auth/login?provider=${provider}&next=${encodeURIComponent("/")}`;

export const SignIn = ({
  error,
}: {
  readonly error: string | null;
}): React.JSX.Element => {
  return (
    <AuthFrame
      eyebrow="Secure sign in"
      title="Return to your practice."
      description="Your session stays in an encrypted, httpOnly cookie. The dashboard never handles an access token."
    >
      {error === null ? null : (
        <p className="error-message mb-5">
          Sign-in did not complete. Please try again.
        </p>
      )}

      <div className="space-y-3">
        <a href={login("google")} className="primary-button w-full">
          {/* Inline mark: an external image would be a third-party request on
              the sign-in page, which is the page most worth keeping clean. */}
          <svg viewBox="0 0 24 24" className="h-5 w-5" aria-hidden="true">
            <path
              fill="#4285F4"
              d="M23.5 12.3c0-.8-.1-1.6-.2-2.3H12v4.5h6.5a5.6 5.6 0 0 1-2.4 3.7v3h3.9c2.3-2.1 3.5-5.2 3.5-8.9z"
            />
            <path
              fill="#34A853"
              d="M12 24c3.2 0 5.9-1.1 7.9-2.9l-3.9-3c-1.1.7-2.4 1.2-4 1.2-3.1 0-5.7-2.1-6.6-4.9H1.4v3.1A12 12 0 0 0 12 24z"
            />
            <path
              fill="#FBBC05"
              d="M5.4 14.4a7.2 7.2 0 0 1 0-4.6V6.7H1.4a12 12 0 0 0 0 10.8l4-3.1z"
            />
            <path
              fill="#EA4335"
              d="M12 4.8c1.8 0 3.4.6 4.6 1.8l3.4-3.4A12 12 0 0 0 1.4 6.7l4 3.1C6.3 6.9 8.9 4.8 12 4.8z"
            />
          </svg>
          Continue with Google
        </a>

        <a href={login("authkit")} className="secondary-button w-full">
          Continue with email
        </a>
      </div>

      <p className="mt-6 text-xs leading-5 text-[var(--dim)]">
        By continuing, you agree to Vakilat&rsquo;s terms and privacy policy. Legal
        outputs remain subject to advocate review.
      </p>
    </AuthFrame>
  );
};
